import { post } from './httpCalls';

export const load = address => {
    const url = '/api/loadAddress';
    const vars = { address };
    return post(url, vars);
}